'use client'

import React from 'react'
import type { TopicPageHeadingFragment } from '../../../.graphql/generated-types'
import {
  backgroundColors,
  defaultBackgroundColour,
} from '../ComposeComponentTopic'

export interface TopicPageHeadingProps {
  data: TopicPageHeadingFragment
}

export function TopicPageHeading({ data }: TopicPageHeadingProps) {
  if (data.name && data.slug && data.background) {
    const {
      name,
      background: { colour: backgroundColour },
    } = data
    const bgColorClassName: string =
      backgroundColors[backgroundColour ?? ''] ?? defaultBackgroundColour

    return (
      <>
        <div
          style={{
            backgroundImage: `url(${data.background.image?.url ?? ''})`,
          }}
          className={`flex items-center justify-center rounded ${bgColorClassName} my-12 bg-[length:55rem] bg-center bg-repeat p-6 md:p-6 md:py-8`}
        >
          <h1 className="text-center text-2xl font-bold text-white md:text-3xl">
            Topic: {name}
          </h1>
        </div>
      </>
    )
  }
  return null
}
